/**
 * ATC Banner Product Recommendations
 * Uses Shopify Section Rendering API to get real product-grid-item cards.
 * After injection: unlazies rimg images, wires up ATC via AddToCartFlyout.
 */
(function () {
  'use strict';

  document.addEventListener('addToCartFlyout:complete', function (e) {
    var detail = e.detail;
    if (!detail || !detail.success || !detail.responseData) return;

    var productId = detail.responseData.product_id;
    if (!productId) return;

    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var flyout = document.querySelector('[data-site-header] [data-atc-banner][data-animation-state="open"]');
      if (flyout) {
        clearInterval(poll);
        var container = flyout.querySelector('[data-atc-banner-recommendations]');
        if (container) {
          fetchRecommendations(productId, container);
        }
      }
      if (attempts > 50) clearInterval(poll);
    }, 100);
  });

  function fetchRecommendations(productId, container) {
    var url = '/recommendations/products?product_id=' + productId
      + '&limit=8'
      + '&section_id=atc-recommendations';

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to fetch recommendations');
        return r.text();
      })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        var slides = temp.querySelectorAll('.atc-recs__slide');
        if (!slides.length) {
          container.style.display = 'none';
          return;
        }

        var heading = container.getAttribute('data-heading') || 'אולי תאהבו גם';

        var wrapperHtml = '<div class="atc-recs">';
        wrapperHtml += '<h2 class="atc-recs__heading">' + heading + '</h2>';
        wrapperHtml += '<div class="atc-recs__slider" data-atc-recs-slider>';

        slides.forEach(function (slide) {
          wrapperHtml += slide.outerHTML;
        });

        wrapperHtml += '</div></div>';

        container.innerHTML = wrapperHtml;
        container.style.display = '';

        processInjectedCards(container);
        initSlickSlider(container);
      })
      .catch(function (err) {
        console.warn('ATC recommendations error:', err);
        container.style.display = 'none';
      });
  }

  function processInjectedCards(container) {
    fixLazyImages(container);
    wireUpATCButtons(container);
  }

  function fixLazyImages(container) {
    var lazyImgs = container.querySelectorAll('img[data-rimg="lazy"]');
    lazyImgs.forEach(function (img) {
      var template = img.getAttribute('data-rimg-template');

      if (template) {
        var maxAttr = img.getAttribute('data-rimg-max');
        var maxW = 512;
        if (maxAttr) {
          maxW = parseInt(maxAttr.split('x')[0], 10) || 512;
        }

        var widths = [200, 300, 400, 512];
        var srcset = [];
        widths.forEach(function (w) {
          if (w <= maxW) {
            srcset.push(template.replace('{size}', w + 'x') + ' ' + w + 'w');
          }
        });

        if (srcset.length > 0) {
          img.setAttribute('srcset', srcset.join(', '));
        } else {
          img.setAttribute('srcset', '');
        }
      } else {
        img.setAttribute('srcset', '');
      }

      img.setAttribute('data-rimg', 'loaded');
    });

    container.querySelectorAll('noscript[data-rimg-noscript]').forEach(function (ns) { ns.remove(); });
    container.querySelectorAll('[data-rimg-canvas]').forEach(function (c) { c.remove(); });
  }

  function wireUpATCButtons(container) {
    var settingsEl = document.querySelector('[data-quick-buy-settings]')
      || container.querySelector('[data-quick-buy-settings]');
    var settings = { cart_redirection: false, money_format: '' };
    if (settingsEl) {
      try { settings = JSON.parse(settingsEl.textContent); } catch (e) {}
    }

    // Single-variant: data-quick-buy → use AddToCartFlyout (same as Empire.js)
    var quickBuyBtns = container.querySelectorAll('[data-quick-buy]');
    quickBuyBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!window.AddToCartFlyout) {
          var vid = btn.getAttribute('data-variant-id');
          if (vid) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            }).then(function () {
              window.location.href = window.Theme.routes.cart_url;
            });
          }
          return;
        }

        var variantID = btn.getAttribute('data-variant-id');
        var formData = [
          { name: 'id', value: variantID },
          { name: 'quantity', value: 1 }
        ];
        var options = {
          atcButton: btn,
          settings: {
            moneyFormat: settings.money_format || null,
            cartRedirection: settings.cart_redirection || false
          }
        };

        new window.AddToCartFlyout(formData, options);
      });
    });

    // Multi-variant: redirect to product page
    var quickShopBtns = container.querySelectorAll('[data-quickshop-slim], [data-quickshop-full]');
    quickShopBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var itemEl = btn.closest('[data-product-quickshop-url]');
        if (itemEl) {
          window.location.href = itemEl.dataset.productQuickshopUrl;
        }
      });
    });
  }

  function initSlickSlider(container) {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(function () { initSlickSlider(container); }, 100);
      return;
    }

    var $slider = jQuery(container).find('[data-atc-recs-slider]');
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;

    $slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      rtl: true,
      arrows: true,
      dots: false,
      speed: 300,
      adaptiveHeight: false,
      prevArrow: '<button type="button" class="atc-recs__arrow atc-recs__arrow--prev" aria-label="הקודם"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
      nextArrow: '<button type="button" class="atc-recs__arrow atc-recs__arrow--next" aria-label="הבא"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
    });
  }
})();
